<nb-card style="min-height: 700px">
  <nb-card-header>
    <h3 style="position: relative" i18n>Robot Part Health</h3>
  </nb-card-header>
  <nb-card-body>
    <div style="min-height: 700px; overflow: auto; padding: 1.143em; box-sizing: border-box">
      <div class="container" style="max-width: 800px">
        <div style="margin: 10px">
          <ng-container>
            <div class="formgroupmodal">
              <div>
                <h4 i18n>Select a robot:</h4>
                <br />
                <div class="row">
                  <div class="col-auto" style="width: 100%">
                    <ng-select
                      [(ngModel)]="selectedRobot"
                      [groupBy]="groupByFn"
                      (change)="robotIdAdd($event)"
                      (clear)="robotIdClear()"
                    >
                      <ng-container>
                        <ng-option *ngFor="let p of commonRobots" [value]="p"> {{ p.name }} - {{ p.id }} </ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                </div>
              </div>
              <br />
            </div>
            <div *ngIf="spin" class="wrapper">
              <div class="centered">
                <app-spinner></app-spinner>
              </div>
            </div>
            <form *ngIf="partHealth?.part_counters?.length" (ngSubmit)="onSubmit()">
              <h5 i18n>Robot parts</h5>
              <br />
              <div *ngFor="let part of partHealth.part_counters; let i = index">
                <nb-card accent="success" style="width: 100%; margin: auto">
                  <nb-card-body>
                    <div class="row">
                      <div class="col"><label i18n>Part ID:</label></div>
                      <div class="col">
                        {{ part.part_id }}
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col"><label i18n>Part Name:</label></div>
                      <div class="col">
                        {{ part.part_name }}
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col"><label i18n>Counter Category:</label></div>
                      <div class="col">
                        {{ part.counter_category }}
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col"><label i18n>Count Type:</label></div>
                      <div class="col">
                        {{ part.count_type }}
                      </div>
                    </div>
                    <br />
                    <div *ngIf="part.count_type != 'minutes'">
                      <div class="row">
                        <div class="col"><label i18n>Count Used:</label></div>

                        <div class="col">
                          {{ part.count_used }}
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col"><label i18n>Count Remaining:</label></div>
                        <div class="col">
                          {{ part.count_remaining }}
                        </div>
                      </div>
                      <br />
                    </div>

                    <div *ngIf="part.count_type == 'minutes'">
                      <div class="row">
                        <div class="col"><label i18n>Minutes Used:</label></div>
                        <div class="col">
                          {{ part.minutes_used }}
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col"><label i18n>Minutes Remaining:</label></div>
                        <div class="col">
                          {{ part.minutes_remaining }}
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="slider-row">
                      <div class="col"><label i18n>Counter Bar Percentage:</label></div>
                      <div class="col">
                        <mat-slider
                          class="custom-slider"
                          min="0"
                          max="100"
                          step="1"
                          discrete
                          [displayWith]="formatLabel"
                        >
                          <input
                            (change)="onSliderChange($event, i)"
                            matSliderThumb
                            [value]="part.counter"
                            [name]="'counter' + i"
                            [(ngModel)]="part.counter"
                          />
                        </mat-slider>
                      </div>
                      <div class="col">{{ part.counter }}%</div>
                    </div>
                  </nb-card-body>
                </nb-card>
              </div>
              <div style="margin-top: 10px">
                <button type="submit" nbButton status="primary" [disabled]="submitting">
                  <span *ngIf="!submitting" i18n>Submit</span>
                  <span *ngIf="submitting" i18n>Saving...</span>
                </button>
              </div>
            </form>
          </ng-container>
        </div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
